import ModalCopy from 'components/modal/ModalCopy';
import { useState, useEffect } from 'react';
import useCreateTrigger from '../queries/useCreateTrigger';
import useGetTriggerByID from '../queries/useGetTriggerByID';
import NameField from '@/components/forms/new/formikFormFields/NameField';

const TriggerCopyModal = ({
    triggerID,
    setSelectedTriggerId,
    resetToMainTable,
    isOpen,
    onClose,
    darkMode,
    switchMode,
}) => {
    const [formData, setFormData] = useState({});
    const [copyingTriggerName, setCopyingTriggerName] = useState('');
    const [isQueryEnabled, setIsQueryEnabled] = useState(false);

    useEffect(() => {
        if (
            isOpen &&
            triggerID &&
            triggerID !== null &&
            triggerID !== undefined
        ) {
            setIsQueryEnabled(true);
        } else {
            setIsQueryEnabled(false);
        }
    }, [isOpen, triggerID]);

    useEffect(() => {
        if (!isOpen) {
            setIsQueryEnabled(false);
            setFormData({});
            setCopyingTriggerName('');
        }
    }, [isOpen]);

    const { isLoading: isLoadingTrigger } = useGetTriggerByID(
        isQueryEnabled ? triggerID : null,
        setFormData,
        resetToMainTable,
        false,
        isQueryEnabled,
        setCopyingTriggerName,
    );

    const handleClose = () => {
        setFormData({});
        setIsQueryEnabled(false);
        onClose();
    };

    const { mutate: copyTrigger, isLoading: isCopying } = useCreateTrigger(
        formData,
        false,
        { ...resetToMainTable, onClose },
        true,
        setSelectedTriggerId,
        switchMode,
    );

    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleCopy = () => {
        setIsQueryEnabled(false); // Disable query before copying
        copyTrigger();
    };

    return (
        <ModalCopy
            type="Trigger"
            name={copyingTriggerName}
            isOpen={isOpen}
            handleClose={handleClose}
            handleSubmit={handleCopy}
            closeWalkthroughId=""
            deleteWalkthroughId=""
            isDisabled={false}
            isSaving={isCopying}
            isLoading={isLoadingTrigger}>
            <NameField
                id="name"
                name="name"
                value={formData?.name || ''}
                onChange={handleChange}
                placeholder="Enter new trigger name"
                width="100%"
                darkMode={darkMode}
            />
        </ModalCopy>
    );
};

export default TriggerCopyModal;
